import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { WebOrderDeliveryTimeSlotSetup } from 'src/app/shared/models/web-order-delivery-time-slot-setup';
import { WebOrderDto } from 'src/app/shared/models/weborderdto';
import { WebOrderMinimumDateTimeSetup } from 'src/app/shared/models/weborderminimumdatetimesetup';
import { ProductService } from 'src/app/shared/services/product.service';
import { ToastService } from 'src/app/shared/services/toastr.service';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'app-edit-delivery-details-dialog',
  templateUrl: './edit-delivery-details-dialog.component.html',
  styleUrls: ['./edit-delivery-details-dialog.component.scss']
})
export class EditDeliveryDetailsDialogComponent implements OnInit {


  // dialogData: any = {};
  currentUrl: string = '';

  order: WebOrderDto = new WebOrderDto();
  webOrderDeliveryTimeSlotSetup: WebOrderDeliveryTimeSlotSetup[] = [];
  allWebOrderDeliveryTimeSlotSetup: WebOrderDeliveryTimeSlotSetup[] = [];
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  deliveryDate: any;
  deliveryTime: any;
  defaultDate: any;
  maxDeliveryDate: any;
  minimumDeliveryTime: any;

  // Flat calendar state
  calendarDays: any[] = [];
  currentMonth: number = 0;
  currentYear: number = 0;
  weekDays: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  constructor(
    private cartService: ProductService,
    private apiFactory: APIFactoryEndPoints,
    private toastService: ToastService,
    private dialogRef: MatDialogRef<EditDeliveryDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    // Data will be set via componentInstance.dialogData
  }

  ngOnInit(): void {
    this.currentUrl = getWindow().location.hostname;
    console.log('Dialog Data:', this.dialogData);
    if (this.dialogData) {
      this.order = this.dialogData.order || new WebOrderDto();

      if (this.order) {
        this.deliveryDate = this.order.deliveryDate;
        this.deliveryTime = this.order.deliveryTime;
        this.defaultDate = this.order.deliveryDate;
        this.getProductDeliveryTimeAndStockDetails();
      }
    }
  }

  getProductDeliveryTimeAndStockDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.cartService.getMinimumDateTimeDetails(this.apiFactory.getWebOrderMinimumDateTimeDetails, this.currentUrl).subscribe((data) => {
        if (data) {
          this.webOrderMinimumDateTimeList.deliveryTime = data.deliveryTime;
          this.webOrderMinimumDateTimeList.maxDeliveryTime = data.maxDeliveryTime;

          this.minimumDeliveryTime = this.webOrderMinimumDateTimeList.deliveryTime;

          let maxOrderDuration = moment().add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours")
            .add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes");

          this.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
          console.log('Max Delivery Date:', this.maxDeliveryDate);

          this.cartService.getTimeSlotList(this.apiFactory.getTimeSlotDetailsByUrl, this.currentUrl).subscribe((slotData) => {
            // Add formatted timeSlot property
            this.webOrderDeliveryTimeSlotSetup = slotData.map(element => ({
              ...element,
              timeSlot: `${element.fromTime}-${element.toTime}`
            }));
            this.allWebOrderDeliveryTimeSlotSetup = [...this.webOrderDeliveryTimeSlotSetup];
            console.log('webOrderDeliveryTimeSlotSetup:', this.webOrderDeliveryTimeSlotSetup);
            this.dateChanged();
          }, reject);
        } else {
          reject("Invalid delivery data");
        }
      }, reject);
    });
  }

  dateChanged() {

    this.deliveryDate = this.deliveryDate
      ? moment(this.deliveryDate).format("YYYY-MM-DD")
      : null;

    const firstProduct = this.order;

    if (!firstProduct) {
      return;
    }
    // Future date => all slots
    if (this.deliveryDate !== firstProduct.deliveryDate) {
      console.log(this.webOrderDeliveryTimeSlotSetup)


      this.webOrderDeliveryTimeSlotSetup = [
        ...this.allWebOrderDeliveryTimeSlotSetup
      ];

    } else {

      // Minimum delivery date => filter using current time
      const now = moment();

      const hours = Number(this.minimumDeliveryTime.split(':')[0]);
      const minutes = Number(this.minimumDeliveryTime.split(':')[1]);

      const minimumDeliveryMoment = now
        .clone()
        .add(hours, 'hours')
        .add(minutes, 'minutes');

      const currentMinutes =
        minimumDeliveryMoment.hours() * 60 +
        minimumDeliveryMoment.minutes();

      this.webOrderDeliveryTimeSlotSetup =
        this.webOrderDeliveryTimeSlotSetup.filter(slot => {

          const fromMinutes =
            Number(slot.timeSlot.split("-")[0].split(":")[0]) * 60 +
            Number(slot.timeSlot.split("-")[0].split(":")[1]);

          return fromMinutes > currentMinutes;
        });
    }

    if (
      !this.webOrderDeliveryTimeSlotSetup.some(
        s => s.timeSlot === this.deliveryTime
      )
    ) {
      this.deliveryTime =
        this.webOrderDeliveryTimeSlotSetup[0]?.timeSlot;
    }
  }

  onConfirmClick() {
    if (!this.deliveryTime) {
      this.toastService.showErrorToast('Choose Delivery Slot');
      return;
    }

    this.order.deliveryDate = moment(this.deliveryDate).format("YYYY-MM-DD");
    this.order.deliveryTime = this.deliveryTime;
    this.cartService.updateWeborder(this.apiFactory.updateWeborder, this.order.orderNo, this.order.deliveryDate, this.order.deliveryTime).subscribe((response: any) => {
      if (response.data) {
        this.toastService.showSuccessToast(response.data);
        this.dialogRef.close({
          data: this.order
        });
      }
    });
  }

  getSelectedSlot() {
    return this.webOrderDeliveryTimeSlotSetup?.find(
      d => d.timeSlot === this.deliveryTime
    );
  }

  formatTime12Hour(timeRange: string): string {
    if (!timeRange) return '';

    const format = (time: string): string => {
      const [hourStr, minuteStr] = time.trim().split(':');
      let hour = +hourStr;
      const minute = minuteStr || '00';

      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      hour = hour === 0 ? 12 : hour;

      return `${hour}:${minute} ${ampm}`;
    };

    const [start, end] = timeRange.split('-');

    return `${format(start)} - ${format(end)}`;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
